var map = {
	"./campaign-logo-alphabet.svg": 551,
	"./campaign-logo-amazon.svg": 552,
	"./campaign-logo-bank-of-america.svg": 553,
	"./campaign-logo-barclays.svg": 554,
	"./campaign-logo-bnp-paribas.svg": 555,
	"./campaign-logo-coca-cola.svg": 556,
	"./campaign-logo-goldman-sachs.svg": 557,
	"./campaign-logo-hsbc.svg": 530,
	"./campaign-logo-ikea.svg": 558,
	"./campaign-logo-jp-morgan.svg": 559,
	"./campaign-logo-meta.svg": 560,
	"./campaign-logo-morgan-stanley.svg": 561,
	"./campaign-logo-oracle.svg": 562,
	"./campaign-logo-pwc.svg": 563,
	"./campaign-logo-walmart.svg": 564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1332;